import React from 'react';
import { Row, Column } from 'components/shared/Layout';
import Spinner from './Spinner';

const FullPageSpinner = () => (
  <Row span={16} height="100vh" data-testid="full-page-spinner">
    <Column justifyContent="center" alignItems="center">
      <Spinner />
    </Column>
  </Row>
);

export default FullPageSpinner;
